import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../../helpers/functions';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStripeSubscriptionStatus } from '../../redux/businessAccount/stripeAction';

function ProtectedRoute({ component, path }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const { userData } = useSelector((state) => state.user);
    const { subscriptionStatus, subscriptionStatusLoading } = useSelector(
        (state) => state.businessDetails
    );
    const hasSubscription = Boolean(subscriptionStatus?.hasSubscription);
    const isStripeConnected = userData?.stripe_connect_charges_enabled === true;

    useEffect(() => {
        if (isAuthenticated() && userData?.role === 'business' && userData?.email) {
            dispatch(fetchStripeSubscriptionStatus(userData.email));
        }
    }, [dispatch, userData?.email, userData?.role]);

    if (isAuthenticated() && userData?.role === 'business') {
        if (subscriptionStatusLoading) {
            return null;
        }

        if (!subscriptionStatus) {
            return <Redirect to="/pricing-plan" />;
        }

        if (!hasSubscription) {
            return <Redirect to="/pricing-plan" />;
        }

        if (hasSubscription && !isStripeConnected) {
            const allowedPrefixes = [
                '/dashboard/setting',
                '/dashboard/services',
                '/dashboard/sub_categories',
                '/dashboard/members',
            ];

            const isAllowed =
                location.pathname === '/dashboard' ||
                location.pathname === '/dashboard/' ||
                allowedPrefixes.some(
                    (p) => location.pathname === p || location.pathname.startsWith(p + '/')
                );

            if (!isAllowed) {
                return <Redirect to="/dashboard" />;
            }
        }

        return <Route component={component} path={path} />;
    }

    return <Redirect to="/login" />;
}

ProtectedRoute.propTypes = {
    component: propTypes.object.isRequired,
    path: propTypes.string.isRequired,
};

export default ProtectedRoute;
